<div class="container mt-4">
    <div class="row">
        <div class="col-md-8 offset-md-2">
            <h1>Contact for Quote</h1>
            <p>
                Please complete this form to begin your quote request, or contact us directly at
                <a href="mailto:Tactical@BornPrimitive.com">Tactical&#64;BornPrimitive.com</a>, or by calling
                <a href="tel:+17579792547">+1(757) 979-2547</a>.
            </p>
        </div>
    </div>
</div>
<div class="container mb-5">
    <div class="row">
        <div class="col-md-8 offset-md-2">
            <div class="success">
                <p>
                    {{success}}
                </p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-8 offset-md-2">
            <form name="taa-berry" (submit)="submitForm($event)" (input)="enableOrDisableSubmit($event)"
                [class.disabled]="disabled">
                <input type="hidden" name="form-name" value="TAA Berry">
                <fieldset class="border py-2 px-4">
                    <legend class="float-none w-auto p-2">Your Interest</legend>
                    <div class="form-group">
                        <label for="category">Category of Interest</label>
                        <select name="category of interest" id="category" [disabled]="disabled">
                            <option value="Born Primitive Tactical">Born Primitive Tactical</option>
                            <option value="TAA">TAA - Not Available</option>
                            <option value="Berry">Berry - Not Available</option>
                            <option value="TAA, Berry">Both TAA &amp; Berry - Not Available</option>
                        </select>
                        <label for="color">Color of Interest</label>
                        <select name="color of interest" id="color" [disabled]="disabled">
                            <option *ngFor="let color of colorsOfInterest" [value]="color">{{ color }}</option>
                        </select>
                        <label style="display: none;" for="quantity">Quantity</label>
                        <select style="display: none;" name="Quantity of interest" id="quantity" [disabled]="disabled">
                            <option value="50-100">1 - 100</option>
                            <option value="100-500">100 - 500</option>
                            <option value="500+">500+</option>
                        </select>
                    </div>
                </fieldset>
                <fieldset class="border py-2 px-4">
                    <legend class="float-none w-auto p-2">Contact Information</legend>
                    <div class="form-group">
                        <label for="first-name">First Name</label>
                        <input autocomplete="name" type="text" name="first-name" id="first-name" required
                            [disabled]="disabled">
                        <label for="last-name">Last Name</label>
                        <input autocomplete="family-name" type="text" name="last-name" id="last-name" required
                            [disabled]="disabled">
                    </div>
                    <div class="form-group">
                        <label for="email">Email</label>
                        <input type="email" name="email" id="email" required [disabled]="disabled">
                        <label for="confirm-email">Confirm Email</label>
                        <input type="email" name="confirm-email" id="confirm-email" required [disabled]="disabled">
                    </div>
                    <div class="form-group">
                        <label for="phone">Phone</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <button class="btn btn-outline-dark dropdown-toggle smaller-btn" type="button"
                                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                    [disabled]="disabled">
                                    <span class="selected-flag">
                                        {{ selectedCountry.flag }}
                                    </span>
                                    {{ selectedCountry.dialCode }}
                                </button>
                                <input type="hidden" name="phone-country-code" id="countryCode"
                                    [value]="selectedCountry.dialCode">
                                <input type="hidden" name="phone-country" id="countryName"
                                    [value]="selectedCountry.name + ' ' + selectedCountry.flag">
                                <div class="dropdown-menu">
                                    <button class="dropdown-item" *ngFor="let country of phoneCountries"
                                        (click)="selectCountry(country)">
                                        <span class="flag">{{ country.flag }}</span> {{ country.name }} ({{
                                        country.dialCode }})
                                    </button>
                                </div>
                            </div>
                            <input type="tel" id="phone" name="phone" class="form-control" [disabled]="disabled">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="company">Company</label>
                        <input type="text" name="company" id="company" required [disabled]="disabled">
                    </div>
                    <div class="form-group">
                        <label for="unit-agency">Unit/Agency</label>
                        <input type="text" name="unit-agency" id="unit-agency" required [disabled]="disabled">
                    </div>
                    <div class="form-group">
                        <label for="country">Country</label>
                        <select autocomplete="off" name="country" id="country" required
                            (change)="displayProvinces($event)" [disabled]="disabled">
                            <option value="">Select a country</option>
                            <option *ngFor="let country of countries" [value]="country.code">
                                {{ country.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="state">Province/State</label>
                        <select autocomplete="off" name="state" id="state" required [disabled]="disabled">
                            <option value="">Select a province/state</option>
                            <option *ngFor="let province of provinces" [value]="province.key">
                                {{ province.label }}
                            </option>
                        </select>
                    </div>
                </fieldset>
                <button style="margin-top: 1rem;" type="submit" disabled class="btn btn-primary extended">
                    SUBMIT INQUIRY
                </button>
            </form>
        </div>
    </div>
</div>
